import { IBlockDefinition, IBlockProps } from '@fox/blocks/contracts/block';
import { ComponentType, createContext, ReactNode, useContext } from 'react';

type BlockComponentContextValue = {
	getBlockComponent: (type: string) => ComponentType<IBlockProps<any>> | undefined;
};

const Context = createContext<BlockComponentContextValue | null>(null);

export const BlockComponentContextProvider = (props: { children: ReactNode; formBlocks: IBlockDefinition[] }) => {
	const { children, formBlocks } = props;
	const getBlockComponent = (type: string) => formBlocks?.find(c => c.type === type)?.Component;
	return <Context.Provider value={{ getBlockComponent }}>{children}</Context.Provider>;
};

export const useBlockComponentContext = () => {
	const context = useContext(Context);
	if (!context) {
		throw new Error('useBlockComponentContext must be used within a BlockComponentContextProvider');
	}
	return context;
};

Context.displayName = 'BlockComponentContext';
